import { Text, HStack, Grid, GridItem, Center, VStack, Skeleton } from "@reverb-ui/react";
import { DayPartingFooterTable } from "../../containers/DayParting/DayPartingFooterTable";
import { HourSideTable } from "../../containers/DayParting/HourSideTable";

const isLoaded : boolean = false;

export const DayPartingTableSkeleton = () => {
    const daysWeek = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"]
    const hoursDay = [
        "12 AM", "01 AM", "02 AM", "03 AM", "04 AM", "05 AM", "06 AM", "07 AM", "08 AM", "09 AM", "10 AM", "11 AM", 
        "12 PM", "01 PM", "02 PM", "03 PM", "04 PM", "05 PM", "06 PM", "07 PM", "08 PM", "09 PM", "10 PM", "11 PM"
    ];
  return (
    <Grid templateColumns="4.43rem repeat(7,1fr)" templateRows="repeat(25,1fr)">
    <HourSideTable />
    <GridItem rowSpan={24} colSpan={7} marginBottom="1">
      <HStack width="full" justifyContent="space-between" spacing="2px">
        {daysWeek.map((index) => (
          <VStack flex={1} width="full" spacing="2px" key={index}>
            {hoursDay.map((value, index) => (
              <Skeleton isLoaded={isLoaded} width={"100%"} key={index}>
                <Center flex={1} width="full" py={2}>
                  <Text fontSize="sm">value</Text>
                </Center>
              </Skeleton>
            ))}
          </VStack>
        ))}
      </HStack>
      </GridItem>
      <DayPartingFooterTable>
        {daysWeek.map((value, index) => (
          <Center flex={1} key={index}>
            <Text fontSize="xs" color="gray.500" fontWeight="semibold">
              <Text fontSize="xs" color="gray.500" fontWeight="semibold">
                {value}
              </Text>
            </Text>
          </Center>
        ))}
      </DayPartingFooterTable>
    </Grid>
  );
};
